import React, { useCallback } from "react";
import { TableRow, TableCell, Checkbox, Tooltip } from "@material-ui/core";
import ElipsisCell from "../../../DesignSystem/Table/Cells/ElipsisTextCell";
import Button from "../../../DesignSystem/button";
import CheckboxIcon from "../../../../assets/images/checkbox-unchecked.svg";
import CheckboxCheckedIcon from "../../../../assets/images/checkbox-checked.svg";
import SoldIcon from "../../../../assets/images/sold-icon.svg";
import EditIcon from "../../../../assets/images/edit-icon.svg";
import { areYouSureToaster, getCityState } from "../../../../utils/methods";
import { PortStatus, CCStatus } from "../../../../enums";
import TitleSubtitle from "../../../DesignSystem/Table/Cells/TitleSubtitle";
import { PortDetails } from "../../../PortDetails";
import StatusButton from "../PortStatus";
import WVFabricon from "../../../../assets/images/wavexchange-small-icon.svg";
import WaveXchangeButton from "../WaveXchangeButton";

interface GroupsPortRowProps {
  port: any;
  rowSelected: boolean;
  selected: any[];
  groupId: string;
  selectedUnGroupId: string;
  removeLoadingId: string;
  on_net: boolean;
  onSelectRow: (newSelected: any[]) => void;
  onSaleClick: (port: any) => void;
  onSaleEdit: (port: any) => void;
  onRemoveClick: (port: any) => void;
  onEditBandwidth: (port: any) => void;
  onRequestVerification: (port: any, prefix: string) => void;
  refetch: () => void;
}

const GroupsPortRow: React.FC<GroupsPortRowProps> = ({
  port,
  refetch,
  groupId,
  on_net,
  onRequestVerification,
  onEditBandwidth,
  selectedUnGroupId,
  rowSelected,
  selected,
  removeLoadingId,
  onSelectRow,
  onSaleClick,
  onSaleEdit,
  onRemoveClick,
}) => {
  const handleSelectRow = useCallback(() => {
    const selectedIndex = selected.findIndex((item) => item.nrId == port.port_id || item.purchasePortId == port.purchasePortId);
    let newSelected: any = [];
    if (groupId !== selectedUnGroupId) {
      newSelected = [{ nrId: port.port_id || -1, purchasePortId: port.purchasePortId || -1 }];
    } else if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, [{ nrId: port.port_id || -1, purchasePortId: port.purchasePortId || -1 }]);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }

    onSelectRow(newSelected);
  }, [port.port_id, port.purchasePortId, selected, onSelectRow, groupId, selectedUnGroupId]);

  const handleRequestVerification = useCallback(
    (prefix) => {
      onRequestVerification(port, prefix);
    },
    [onRequestVerification, port]
  );

  const handleEditBandwidth = useCallback(() => {
    onEditBandwidth(port);
  }, [onEditBandwidth, port]);

  const handleSale = useCallback(() => {
    onSaleClick(port);
  }, [onSaleClick, port]);

  const handleEdit = useCallback(() => {
    onSaleEdit(port);
  }, [onSaleEdit, port]);

  const handleRemove = useCallback(() => {
    return areYouSureToaster(onRemoveClick, port, "Are you sure you want to remove this listing?");
  }, [onRemoveClick, port]);

  return (
    <TableRow>
      <TableCell width="3%" className="bd-group-inner-row-1">
        <Checkbox
          classes={{
            root: "selection-checkbox",
          }}
          color="default"
          checked={rowSelected}
          onChange={handleSelectRow}
          icon={<img src={CheckboxIcon} alt="Checkbox" className="checkbox-icon" />}
          checkedIcon={<img src={CheckboxCheckedIcon} alt="Checkbox Checked" className="checkbox-checked-icon" />}
          inputProps={{
            // @ts-ignore
            "data-testid": "checkbox-input",
          }}
          data-testid="checkbox"
        />
      </TableCell>
      <TitleSubtitle
        width="15%"
        bdGroupInnerRow={2}
        align="left"
        maxWidth="15wv"
        title=""
        titleNode={
          <>
            <span style={{ marginRight: "20px" }}>{port.group_name || "-"}</span>
            <PortDetails nrId={port.port_id} refreshIndex={refetch} otherNrId={port.far_port_id} isBandwidth doNotSortLeftRight />
          </>
        }
        subTitle={port.port_name}
      />
      <TableCell className="bd-group-inner-row-3" width="5%">
        <StatusButton verified={port.verified} portStatus={port.status} ccStatus={port.cc_status} />
      </TableCell>
      {/* <TableCell className="green-line bd-group-inner-row-3" width="5%">
        <WaveXchangeButton refresh={refetch} port={port} on_net={on_net} handleRequestVerification={handleRequestVerification} prefix={""} />
      </TableCell> */}
      <TableCell className="bd-group-inner-row-4" />
      <TitleSubtitle
        bdGroupInnerRow={5}
        boldTitle
        width="15%"
        align="left"
        maxWidth="15wv"
        title={port.far_ne_name}
        subTitle={getCityState(port, "far_") || ""}
        isOnNetNE={port.far_on_net}
      />
      <TitleSubtitle width="10%" bdGroupInnerRow={6} align="left" maxWidth="15wv" title={port.far_group_name || "-"} subTitle={port.far_port_name} />
      <TableCell className="bd-group-inner-row-7" width="5%">
        <StatusButton verified={port.far_verified} portStatus={port.status} ccStatus={port.far_cc_status} />
      </TableCell>
      {/* <TableCell className="green-line bd-group-inner-row-7" width="5%">
        <WaveXchangeButton refresh={refetch} port={port} on_net={on_net} handleRequestVerification={handleRequestVerification} prefix={"far_"} />
      </TableCell> */}
      <TableCell className="bd-group-inner-row-8" />
      <TitleSubtitle
        bdGroupInnerRow={9}
        boldTitle
        width="15%"
        align="left"
        maxWidth="15wv"
        title={port.bandwidth_description}
        subTitle={port.provider || port.bandwidth_name}
      />
    </TableRow>
  );
};

export default GroupsPortRow;
